import styled from 'styled-components';
import { colors } from 'styles/colors';

import { devices } from 'styles/devices';

const PhraseLabel = styled.h2`
   display: block;
   font-size: 16px;
   font-weight: 700;
   color: ${colors.primary};
   text-transform: uppercase;

   ${devices.desktopHD} {
      margin-bottom: 14px;
   }
`;

export default PhraseLabel;
